export default function normalizeUrl(url: string) {
  try {
    const { origin, pathname } = new URL(url);
    return origin + pathname.replace(/\/$/, '');
  } catch (e) {
    return url;
  }
}
